// extracted by mini-css-extract-plugin
export default {"CheckInBadge":"styles_CheckInBadge__dZ-HP","text":"styles_text__c2psY"};